import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Configuration } from '../../../app.constants';
import { DownloadService } from '../../services/html-png/html-png.service';
import {TranslateService} from '@ngx-translate/core';
import {StaticValueService} from '../../../shared/services/static-value.service';
import { AssociateService } from '../../../associate/shared/services/associate.service';

@Component({
  selector: 'app-profile-card-popup',
  templateUrl: './profile-card-popup.component.html',
  styleUrls: ['./profile-card-popup.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileCardPopupComponent implements OnInit {
  public associate;
  public serverApiUrl;
  public imagePlaceholder = 'assets/img/profile/blank-profile.png';
  public associateImageUrl: any;


  constructor(
    public dialogRef: MatDialogRef<ProfileCardPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public config: Configuration,
    public staticService: StaticValueService,
    public translateService: TranslateService,
    public htmlPng: DownloadService,
    public associateService: AssociateService) { }


  ngOnInit() {
    this.translateService.use(this.staticService.getLanguage());
    this.serverApiUrl = this.config.StaticImageUrl;
    if (this.data !== null) {
      this.associate = this.data.associate;
    }
    this.associateImageUrl = this.serverApiUrl + this.associate['personalInformation']['avatarUrl'];
    if (this.associate['personalInformation']['gender'].includes('Male')) {
      this.imagePlaceholder = 'assets/img/Male-orange.png'
    }else if (this.associate['personalInformation']['gender'].includes('Female')) {
        this.imagePlaceholder = 'assets/img/Female-orange.png'
    }
  }

  cancel() {
    this.dialogRef.close('Cancel');
  }

  viewFullProfile() {
    this.dialogRef.close('Proceed');
  }

  Share() {
    // this.htmlPng.downloadPng(`${this.associate.personalInformation.fullName}_BusinessCard`, 'businessCard');
    this.associateService.exportVcard(this.associate).subscribe(vCard => {
      this.htmlPng.downloadExcel(`${this.associate.personalInformation.fullName}.vcf`, 'text/x-vcard', vCard['vcardUrl'] );
    }, err => {
      console.log('vCard File', err);
    });
    this.dialogRef.close('Share');

  }


}
